import { render, staticRenderFns } from "./view-schedule-teacher.vue?vue&type=template&id=4041011a&"
import script from "./view-schedule-teacher.vue?vue&type=script&lang=js&"
export * from "./view-schedule-teacher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports